import {
  FormProvider,
  type SubmitHandler,
  useFieldArray,
  useForm,
} from "react-hook-form";
import DisabledPositioningList from "src/components/pages/Settings/YachtSetUp/PositioningList/DisabledPositioningList";
import PositioningEquipment from "src/components/pages/Settings/YachtSetUp/PositioningList/PositioningEquipment";
import PositioningList from "src/components/pages/Settings/YachtSetUp/PositioningList/PositioningList";
import YachtSetupSectionHeader from "src/components/pages/Settings/YachtSetUp/YachtSetupSectionHeader";
import Loader from "src/components/shared/Loader/Loader";
import { useGetApi, usePostApi } from "src/hooks";
import { PageContainer } from "src/styled";
import { getYachtId } from "src/utils";
import { Notification } from "src/utils/Notification";

import {
  type IPositioningForm,
  type IPositionItem,
} from "./DynamicPositioningSetup.types";

const mapPositioning = (
  data: any,
): IPositioningForm & { disabledList: IPositionItem[] } => {
  const list: IPositionItem[] = [];
  const disabledList: IPositionItem[] = [];
  if (data?.data?.content?.data?.list) {
    data.data.content.data.list.forEach((el: IPositionItem) => {
      if (el.disabled) disabledList.push(el);
      else list.push(el);
    });
  }
  return { ...data?.data?.content?.data, list, disabledList };
};

const DynamicPositioningSetup = () => {
  const { data, isLoading: isGetLoading } = useGetApi({
    request: "get-settings",
    body: { params: { sect: "_dps" } },
    mapper: mapPositioning,
  });

  const { post, isLoading: isPostLoading } = usePostApi();

  const methods = useForm<IPositioningForm>({
    values: {
      list: data?.list ?? [],
      equip: data?.equip ?? "",
      equipclass: data?.equipclass ?? "",
    },
  });

  const { append, ...fieldArrayProps } = useFieldArray<IPositioningForm>({
    control: methods.control,
    name: "list",
  });

  const handleAppend = () => {
    append({ code: "", desc: "" });
  };

  const onSubmit: SubmitHandler<IPositioningForm> = async data => {
    const params = {
      data,
      section: "dynpos",
      yachtid: getYachtId(),
    };

    await post({
      request: "save-yacht-info",
      body: { params },
      onSuccess: () => {
        Notification(
          "Success",
          "Dynamic Positioning has been successfully changed.",
          "green",
        );
      },
    });
  };

  return (
    <PageContainer>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <YachtSetupSectionHeader
            onAdd={handleAppend}
            isSaving={isPostLoading}
            section="dynpos"
          />
          {!data || isGetLoading ? (
            <Loader />
          ) : (
            <>
              <PositioningEquipment />
              <PositioningList {...fieldArrayProps} />
              <DisabledPositioningList list={data?.disabledList ?? []} />
            </>
          )}
        </form>
      </FormProvider>
    </PageContainer>
  );
};

export default DynamicPositioningSetup;
